<template>
  <div class="app-switcher">
    <component :is="currentApp" v-if="currentApp" class="dynamic-component" :settings="settings" :app-data="appData"/>
  </div>
</template>

<script setup>
import {shallowRef, defineAsyncComponent, onMounted, ref, nextTick} from 'vue'
import { listenIncomingMessages } from '@/services/messageEvents.js'
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import ErrorMessage from '@/components/ErrorMessage.vue'

const currentApp = shallowRef(null)
const currentComponentName = ref(null)
const settings = ref(null)
const appData = ref(null)

function switchApp(appName) {
  const asyncComponent = defineAsyncComponent({
    loader: () => import(`@/apps/${appName}/Screen.vue`).catch(() => {
      throw new Error(`Component ${appName} not found`);
    }),
    loadingComponent: LoadingSpinner,
    errorComponent: ErrorMessage,
    delay: 200,
    timeout: 10000
  })

  currentApp.value = asyncComponent
}

onMounted(() => {
  listenIncomingMessages(async ({ component, settings: incomingSettings, appData: incomingAppData },) => {
    if(!component || !incomingSettings) return
    if (component !== currentComponentName.value) {
      switchApp(component)
      currentComponentName.value = component
      await nextTick()
    }
    settings.value = incomingSettings
    appData.value = incomingAppData
  })
})
</script>

<style scoped>
.app-switcher {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
}
.dynamic-component{
  width: 100vw;
  height: 100vh;
}
</style>
